export default __webpack_public_path__ + "static/media/monkey.c58d2611.svg";